// extracted by mini-css-extract-plugin
export default {"chat":"styles_chat__ZdK3w","dropdownContainer":"styles_dropdownContainer__3LbXj","dropdown":"styles_dropdown__QWkbb"};